import React from "react";
import { Typography, Spin, Alert } from "antd";
import { useTranslation } from "react-i18next";
import { CertificateSettingsForm } from "../components/CertificateSettingsForm";
import { useCertificateSettings } from "../hooks/useCertificateSettings";
import PageHeader from "components/Common/PageHeader";
import SideBarSchoolSettings from "feature-module/settings/components/SideBarSchoolSettings";
import SettingsLayout from "feature-module/settings/components/SettingsLayout";

const { Title, Text } = Typography;

export const CertificateSettingsPage: React.FC = () => {
  const { t } = useTranslation();
  const {
    settings,
    isLoading,
    isSubmitting,
    isUploadingSignature,
    handleSubmit,
    handleSignatureUpload,
  } = useCertificateSettings();




  return (
    <SettingsLayout titleKey="instance_settings" loading={isLoading}>

      <CertificateSettingsForm
        initialData={settings || undefined}
        onSubmit={handleSubmit}
        handleSignatureUpload={handleSignatureUpload}
        isSubmitting={isSubmitting}
        isUploadingSignature={isUploadingSignature}
      />

    </SettingsLayout>
  );
};
